
<scaffold-dialog [title]="data.title">
  <div scaffoldDialogBody>
    <p>{{'select_new_location'| translation}}</p>
    <app-folder-structure (folderClicked)="moveTo($event)" [folder]="data.folder" [basefolder]="data.basefolder">
    </app-folder-structure>
  </div>
</scaffold-dialog>
